// MB-I18N-2A — common FR (extrait de LanguageContext, valeurs inchangées).
export default {
  "common.loading": "Chargement...",
  "common.error": "Erreur",
  "common.success": "Succès",
  "common.cancel": "Annuler",
  "common.confirm": "Confirmer",
  "common.save": "Enregistrer",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.back": "Retour",
  "common.notifications": "Notifications",
  "common.no_notifications": "Aucune notification",
  "common.client": "Client",
  "common.required": "Requis",
  "common.optional": "Optionnel",
};
